var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationsIconColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.705,
    height: 43.871,
    viewBox: "0 0 42.705 43.871",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.091,
    y1: 1.031,
    x2: 1.033,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#f37d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#fbbf02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbf02"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2782",
    "data-name": "Rectangle 2782",
    width: 42.705,
    height: 43.871,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2785",
    "data-name": "Groupe 2785",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1966",
    "data-name": "Trac\\xE9 1966",
    d: "M41.4,31.177s-.115-.095-.173-.133A13.943,13.943,0,0,1,36.35,20.455V14.63A14.738,14.738,0,0,0,21.545,0h-.384A14.742,14.742,0,0,0,6.337,14.63v5.825A13.913,13.913,0,0,1,1.459,31.044a1.054,1.054,0,0,0-.173.133A3.622,3.622,0,0,0,0,33.947a3.686,3.686,0,0,0,3.706,3.662h9.678a7.912,7.912,0,0,0,7.777,6.262h.384a7.928,7.928,0,0,0,7.777-6.262H39a3.651,3.651,0,0,0,2.419-6.433ZM9.524,20.455V14.63A11.568,11.568,0,0,1,20.738,3.15a.651.651,0,0,0,.192,0h1A11.568,11.568,0,0,1,33.143,14.63v5.825a17.109,17.109,0,0,0,6.145,13.112c.038.019.058.057.1.076a.511.511,0,0,1,.115.323.542.542,0,0,1-.518.531H3.687a.546.546,0,0,1-.538-.531.511.511,0,0,1,.115-.323.337.337,0,0,0,.1-.076A17.109,17.109,0,0,0,9.505,20.455ZM17.09,37.609h8.545a4.735,4.735,0,0,1-4.282,3.112,4.739,4.739,0,0,1-4.244-3.112Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIconColor);
export default __webpack_public_path__ + "static/media/notificationsIconColor.0ec1878f5e795cc2cfa98c6f93875f15.svg";
export { ForwardRef as ReactComponent };